import { DataBean } from "../DataBean";

export class FixedAsset extends DataBean {

    public async getFixedAsset(idFixedAsset: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "fixedassets.FixedAsset_getFixedAsset_Number", [idFixedAsset]);
    }

    public async getFixedAssetCatalog(idFixedAsset: number, prefix: string, accountID: number, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFixedAssetCatalog_Number_String_Number_Number_Number", [idFixedAsset, prefix, accountID, page, recordsPerPage]);
    }

    public async getFixedAssetByUBLInvoice(idUBLInvoice: number, issueDate: any, itemID: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "fixedassets.FixedAsset_getFixedAssetByUBLInvoice_Number_java.util.Date_Number", [idUBLInvoice, issueDate, itemID]);
    }

    public async updateFixedAsset(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "fixedassets.FixedAsset_updateFixedAsset_fixedassets.FixedAsset", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "fixedassets.FixedAsset"
            }
        ]);
    }
    public async getFixedAssetsItemByList(idEmployee: number, media: string, mediaContext: string): Promise<any> {
        return this.getCustomService("CacheOptions",
            "java.util.List_getFixedAssetsItemByList_Number_String_String", [
            idEmployee,
            media,
            mediaContext
        ]);
    }


}
